// extracted by mini-css-extract-plugin
module.exports = {"popover":"ClickPopover_popover__hJ0Jd","appear":"ClickPopover_appear__Afoya","trigger":"ClickPopover_trigger__Rji_b"};